var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSafety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-safety",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    width: 28,
    height: 28,
    fill: "#fff",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M28.417,33.457v2.37a2.513,2.513,0,0,1-2.51,2.51H3.51A2.513,2.513,0,0,1,1,35.827v-2.37A2.338,2.338,0,0,1,2.758,31.2C3.073,29.226,4.182,24.951,8,22.7c0,0,1.16-.682,1.16-.682l.024,2.692C5.319,26.99,4.97,32.3,4.967,32.355a1.169,1.169,0,0,1-1.165,1.1H3.333v2.37A.177.177,0,0,0,3.51,36h22.4a.177.177,0,0,0,.177-.177v-2.37h-.469a1.167,1.167,0,0,1-1.166-1.144c0-.05-.174-5.276-4.116-7.6,0,0,.024-2.693.024-2.693l1.159.683c3.888,2.289,4.906,6.519,5.172,8.5A2.338,2.338,0,0,1,28.417,33.457ZM8.2,31.124a1.167,1.167,0,0,0,0,2.334h.07s12.868,0,12.868,0,.07,0,.07,0a1.167,1.167,0,0,0,0-2.334Zm2.713-5.45,2.326-4.024a10.091,10.091,0,0,1,2.932,0L18.5,25.674V21.614s0-1.736,0-1.736l-.79-.27a9.9,9.9,0,0,0-3-.4,9.914,9.914,0,0,0-3,.4l-.79.27v1.736S10.917,25.674,10.917,25.674Z",
    transform: "translate(-0.708 -15.21)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSafety);
export default __webpack_public_path__ + "static/media/ico-safety.a30b00e1f25eae07ddff789ef7b8f070.svg";
export { ForwardRef as ReactComponent };